"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  scale: 160,
  xOffset: 0,
  yOffset: 0,
  rotation: [0, 0, 0],
  precision: 0.1
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/lib/projectionConfig.js
// module id = h2uz
// module chunks = 0